import React from "react";
import styled from "styled-components";

const IconEnvelope = () => {
  return (
    <StyledIconEnvelope  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.19 18.38">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="m19.81,6.49s0,0,.01,0L10.7.19c-.18-.13-.4-.19-.61-.19s-.42.06-.61.19L.37,6.48s0,0,.01,0c-.23.19-.38.46-.38.78v10.1c0,.56.46,1.02,1.02,1.02h18.15c.56,0,1.02-.46,1.02-1.02V7.26c0-.32-.15-.59-.38-.78Zm-1.45,2.26l-7,4.5c-.38.25-.82.37-1.26.37s-.88-.12-1.26-.37L1.83,8.75c-.35-.22-.45-.69-.23-1.04.22-.35.69-.45,1.04-.23l7,4.5c.27.18.63.18.9,0l7-4.5c.35-.22.81-.12,1.04.23.22.35.12.81-.23,1.04Z" strokeWidth="0"/>
      </g>
    </StyledIconEnvelope>
  )
};
export default IconEnvelope;

const StyledIconEnvelope = styled.svg`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 1.125em;
  path {
    fill: currentColor;
  }
`